import { xNormed } from 'ml-spectra-processing';
/**
 * Norm the Y values
 * @param data
 * @param options
 */
export function normed(data, options = {}) {
    xNormed(data.y, { ...options, output: data.y });
    return { data };
}
//# sourceMappingURL=normed.js.map